<template lang="html">
  <div class="loaderParent">
    <div class="loader d-block">
      <div :style="width" class="mx-auto popupwidth overflowAuto" style="overflow: auto">
          <div class="card cardPosition p-5">
            <h1 class="mb-5">Accuracy Info</h1>
            <div v-for="(keys, i) in Object.keys(Accuracy)" :key="i" class="d-flex justify-content-around">
              <span>{{keys}}</span>
              <span>RMSE</span>
              <span>{{Accuracy[keys]}}</span>
                <!-- <div class="shell">
                    <div class="bar" :style="{ width: Accuracy[keys] + '%' }">
                        <span class="spanClass">{{ Accuracy[keys] }}%</span>
                    </div>
                </div> -->
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */


export default {
    name: "AccuracyViewer",
  props: {
    Accuracy: {
      type: Object
    }
  },
  components: {
  },
  data() {
    return {
    };
  },
  watch: {
  },
  mounted() {
      $('.loaderParent').click(()=>{
          this.$emit('closeAccuracy')
      })
  },
  computed: {
      width() {
        return "width: 50%";
    },
  },
  methods: {
      crossClose() {
          this.$emit("closePopup");
      }
  }
};
</script>
<style scoped>
.shell {
  height: 20px;
  width: 250px;
  border: 1px solid #aaa;
  border-radius: 13px;
}

.bar {
  background: linear-gradient(to right, #B993D6, #8CA6DB);
  height: 20px;
  width: 15px;
  border-radius: 9px;
}
.spanClass {
    float: right;
    padding: 2px 2px;
    color: #fff;
    font-size: 0.7em
  }
.popupwidth::-webkit-scrollbar {
  display: none;
}
.cardPosition{
    position: absolute;
    width: 50%;
    top: 30%;
}

@media screen and (max-width: 34em) {
  .popupwidth {
    width: 100% !important;
  }
}
.cursor-pointer {
    cursor: pointer;
}
.loaderParent {
  height: 100%;
  width: 100%;
  z-index: 99 !important;
  position: fixed;
  top: 0px;
  left: 0px;
  opacity: 0.98;
  background: #2c3e50;
}
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999 !important;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  background: #2c3e50;
  opacity: 0.98;
}

@keyframes rotation {
  from {
    opacity: 1;
    transform: rotate(0deg);
  }
  to {
    opacity: 1;
    transform: rotate(359deg);
  }
}
</style>
